import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import QuizLayout from "./Shared/QuizLayout";
import Question from "./Shared/Question";
import ResultCard from "./Shared/ResultCard";

export default function PrivateQuiz() {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [selectedTags, setSelectedTags] = useState({});
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [diagnosisFinished, setDiagnosisFinished] = useState(false);

  useEffect(() => {
    fetchQuestions();
  }, []);

  async function fetchQuestions() {
    const snapshot = await getDocs(collection(db, "private_questions"));
    const fetched = snapshot.docs.map((doc) => doc.data());
    setQuestions(fetched);
  }

  function handleAnswer(selectedOption) {
    const newTags = { ...selectedTags };

    for (const [tagType, tagValue] of Object.entries(selectedOption.tags)) {
      newTags[tagType] = new Set([tagValue]); // ← 常に1値だけに上書き
    }

    setSelectedTags(newTags);

    if (currentIndex + 1 < questions.length) {
      setCurrentIndex(currentIndex + 1);
    } else {
      handleSubmit(newTags);
    }
  }

  async function handleSubmit(finalTags) {
    setLoading(true);

    const snapshot = await getDocs(collection(db, "games"));
    const allGames = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const filtered = allGames.filter((game) => {
      const isMatch = Object.entries(finalTags).every(([tagType, valueSet]) => {
        const value = Array.from(valueSet)[0];
        const field = game[tagType];
    
        console.log("🔍 checking:", game.name, tagType, value);
        console.log("🧩 field:", field);
    
        if (value === "neutral") return true;
    
        if (Array.isArray(field)) {
          return field.includes(value);
        }
    
        if (typeof field === "string") {
          return field === value;
        }
    
        if (typeof field === "object" && field !== null) {
          return value in field;
        }
    
        return false;
      });
    
      if (isMatch) {
        console.log("✅ MATCHED GAME:", game.name);
      }
    
      return isMatch;
    });
    

    const shuffled = [...filtered].sort(() => Math.random() - 0.5);
    const selected = shuffled.slice(0, 3);

    setResults(selected);
    setLoading(false);
    setDiagnosisFinished(true);
  }

  function handleRetry() {
    navigate("/");
  }

  if (loading) return <p>診断結果を計算中です…</p>;

  if (results.length > 0) {
    return (
      <div className="min-h-screen bg-[#efeeea] flex flex-col items-center justify-center p-4">
        <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-5xl space-y-6 text-center">
          <h2 className="text-xl font-bold">あなたにぴったりのボードゲーム</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {results.map((game) => (
              <ResultCard key={game.id} game={game} />
            ))}
          </div>
          <button
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            onClick={handleRetry}
          >
            もう一度診断する
          </button>
        </div>
      </div>
    );
  }

  if (
    !loading &&
    diagnosisFinished &&
    results.length === 0 &&
    questions.length > 0
  ) {
    return (
      <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
        <div className="bg-white p-6 rounded-xl shadow-md max-w-md text-center space-y-4">
          <h2 className="text-lg font-semibold">条件に合うゲームが見つかりませんでした</h2>
          <p className="text-sm text-gray-600">
            条件に合うゲームがまだ登録されてないみたい...<br />
            おすすめのゲームがあったら、ぜひ教えてね！
          </p>
          <a
            href="https://example.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            掲載リクエストを送る
          </a>
          <button
            onClick={handleRetry}
            className="block mx-auto mt-4 text-sm text-blue-600 underline"
          >
            診断をやり直す
          </button>
        </div>
      </div>
    );
  }

  if (questions.length === 0) return <p>質問を読み込み中です...</p>;

  return (
    <QuizLayout
      currentIndex={currentIndex}
      total={questions.length}
      onBack={() =>
        currentIndex === 0 ? navigate("/") : setCurrentIndex(currentIndex - 1)
      }
    >
      <Question
        question={questions[currentIndex]}
        onAnswer={handleAnswer}
        selectedTags={selectedTags}
      />
    </QuizLayout>
  );
}
